import BusinessSignup from "../BusinessSignup";
import CreatorSignup from "../CreatorSignup";

const OutroForm = ({ form = "creator", type = "blogger", signupType = undefined }) => {
  return (
    <section className="stippl-outro">
      <div className="stippl-outro__visual"></div>
      <div className="container__inner">
        <div className="stippl-outro__content">
          <div className="cta-form">
            {form === "business" ? <BusinessSignup type={type} signupType={signupType} /> : <CreatorSignup type={type} />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OutroForm;
